import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { FETCH_ALC_CSV_PREVIEW } from "./graphql";

const CsvPreviewModal = ({ csvFileName, hide }) => {
  const { data, loading, error } = useQuery(FETCH_ALC_CSV_PREVIEW, {
    variables: { csv: csvFileName },
    fetchPolicy: "network-only",
  });

  const preview = useMemo(() => {
    if (!data?.alcCsvPreview) return null;
    try {
      return JSON.parse(data.alcCsvPreview);
    } catch (e) {
      console.error("Failed to parse alcCsvPreview", e);
      return null;
    }
  }, [data?.alcCsvPreview]);

  if (loading) {
    return (
      <div className="py-8 flex justify-center">
        <InlineSpinner text="Loading CSV preview..." />
      </div>
    );
  }

  if (error) {
    return <Errors error={error} className="py-6" />;
  }

  if (!preview) {
    return <div className="opacity-70 py-6">No preview data.</div>;
  }

  return (
    <div className="flex flex-col min-h-[300px] max-h-[75vh]">
      <div className="text-xs opacity-70 mb-3">
        Showing {preview.shownRows} / {preview.totalRows} rows
      </div>

      <div className="flex-1 min-h-0 overflow-auto">
        <table className="table with-line w-full text-xs">
          <thead>
            <tr className="bg-gray-50">
              {preview.headers?.map((header, index) => (
                <th key={`${header}-${index}`} className="text-left">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {preview.rows?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell || ""}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex justify-end">
        <Button onClick={hide}>Close</Button>
      </div>
    </div>
  );
};

export default CsvPreviewModal;
